// A '.tsx' file enables JSX support in the TypeScript compiler, 
// for more information see the following page on the TypeScript wiki:
// https://github.com/Microsoft/TypeScript/wiki/JSX
import * as React from 'react';
import * as ReactDom from 'react-dom';
import * as _ from 'lodash';
import Highlighter = require('react-highlight-words');
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { UpdateCartCounts } from '../Global/cart';
declare var dataLayer: any;
declare var launchModal: Function;
declare var AddToCompareCheckbox: Function;

export interface ISearchResultProps {
    rowNum: number,
    query: string,
    result: Array<string>,
    path: string,
    country: string
}

interface ISearchResultState {
    quantityError: boolean,
    tooltipOpen: boolean,
    addedToCompare: boolean,
    addedToCart: boolean
}

export class SearchResult extends React.Component<ISearchResultProps, ISearchResultState> {
    private qtyInput: HTMLInputElement;
    private compareCheckbox: HTMLInputElement;
    private addRemoveSpan: HTMLSpanElement;
    private productDiv: HTMLDivElement;

    constructor(props) {
        super(props);
        this.state = {
            quantityError: false,
            tooltipOpen: false,
            addedToCompare: this.props.result[8] == 'checked',
            addedToCart: this.props.result[15] == 'hidden'
        }
    }

    render() {
        let prices = this.props.result[7] != '' ? JSON.parse(this.props.result[7]) : [];

        return (
            <div className={'results-products-item ' + this.props.result[16]} id={'prd-' + this.props.rowNum} ref={(el) => this.productDiv = el} >
                <div className='best-bet-icon'>Best Match</div>
                <div className='results-products-item-inner'>
                    <div className='results-products-item-image'>
                        <a href={this.props.result[4]} onClick={this._selectItem.bind(this)} >
                            <img className='media-object' src={this.props.result[5]} alt={this.props.result[0]} />
                        </a>
                        <div className='checkbox'>
                            <span className=''>
                                <input id={'compare-' + this.props.rowNum} className='addToCompare' checked={this.state.addedToCompare} data-product-id={this.props.result[1]} onChange={this._addedRemoved.bind(this, this.props.rowNum)} type='checkbox' ref={(el) => this.compareCheckbox = el} />
                                <label htmlFor={'compare-' + this.props.rowNum} ><a href='/compare/'>
                                    Add to Compare
							    </a></label>
                            </span>
                            <span id={'addRemove-' + this.props.rowNum} className='addRemove' ref={(el) => this.addRemoveSpan = el} >
                            </span>
                        </div>
                    </div>
                    <div className='results-products-item-info'>
                        <a href={this.props.result[4]} onClick={this._selectItem.bind(this)} >
                            <h4 className='media-heading'>
                                <Highlighter highlightClassName='highlightClass' autoEscape={true} textToHighlight={this._termCleanup(this.props.result[0])} searchWords={[this._termCleanup(this.props.query)]} />
                            </h4>
                        </a>
                        <div className='part-num'><p>Part #: <Highlighter highlightClassName='highlightClass' autoEscape={true} textToHighlight={this._termCleanup(this.props.result[2])} searchWords={[this._termCleanup(this.props.query)]} /></p>
                            <p>{this._getSKU(prices)}</p>
                        </div>
                        {this.props.result[13] === 'true' &&
                            <p className="results-products-item-price">
                            {/*  BED to do: Remove Static Price below  */}
                            {this.props.result[18] && this.props.result[18].length > 0 && this.props.result[18] !== this.props.result[3] &&
                                <div>
                                    <span className="ea-price-discounted strike">{this.props.result[3]} {this.props.result[9]}</span>
                                    <span className="ea-price-original">{this.props.result[18]} {this.props.result[19]}</span>
                                </div>
                            }
                            {this.props.result[18] === this.props.result[3] &&
                                <span className="ea-price-original">{this.props.result[3]} {this.props.result[9]}</span>
                            }
                            </p>
                        }
                        {this.props.result[13] === 'false' &&
                            <p className="message paragraph-caption">
                                {this.props.result[17]}
                            </p>
                        }


                        {this._getSoldAs()}
                        {this._getPrices(prices)}
                        {this._getAddToCart(prices)}

                        <input type='hidden' id={'sku-' + this.props.rowNum} className='hidden' value={this.props.result[1]} />
                    </div>
                </div>
            </div>
        )
    }

    _getAddToCart(prices) {
        if (prices.length > 0) {
            return (
                <div className="results-products-item-interactions">
                    <div className={`results-products-item-quantity ${this.state.addedToCart ? `hidden` : ``}`}>
                        <div className="results-products-item-quantity-input">
                            <div className='form-group qty'>
                                <label htmlFor={'qty-' + this.props.rowNum}>Qty</label>
                                <input id={'qty-' + this.props.rowNum} type='text' className='form-control search-list-js' pattern='\\d*' defaultValue='1' data-maxqty={this.props.result[12]} onKeyUp={this._qtyCheck.bind(this)} onKeyPress={this._qtyInputCheck.bind(this)} onChange={e => this._qtyCleanInput(e)} ref={(el) => { this.qtyInput = el; }} />
                            </div>
                            {this.state.quantityError ? <div className="qty-error">{'Max Quantity of ' + this.props.result[12]}</div> : ''}
                        </div>
                        <div className="results-products-item-quantity-available">
                            {this.props.result[23] != '' && this.props.result[24] === 'True' ? <p>{this.props.result[23]}</p> : this.props.result[23] != '' && this.props.result[24] === 'False' ? <p>In stock</p> : ''}
                        </div>
                    </div>
                    {!this.state.quantityError ? this._showAddToCartButton() : this._showDisabledButton()}
                    <div className='add-list-ctrl results-products-item-add-list'>
                        <a className='AddToListDialogLink visible-lg-inline-block hidden-xs text-cta' data-idx={this.props.rowNum} data-modal-height='660' data-modal-width='500' href='#' onClick={this._addToDialogClick.bind(this, window.bootstrap.addToWishlistDialogUrl, false)}>Add to List</a>
                        <a className='AddToListLink visible-xs-inline-block hidden-lg hidden-md hidden-sm text-cta' data-idx={this.props.rowNum} href='#' onClick={this._addToClick.bind(this, window.bootstrap.addToWishlistDialogUrl)}>Add to List</a>
                    </div>
                </div>
            );
        }
        else {
            return (
                <div className="results-products-item-inactive">
                    <a href="/contact-us/request-a-quote" className={"add-cart btn btn-plain"}>Request Quote</a>
                </div>
            )
        }
    }

    _getSKU(prices) {
        if (this.props.result[11] != '') {
            return <span>Manufacturer SKU: <Highlighter highlightClassName='highlightClass' autoEscape={true} textToHighlight={this._termCleanup(this.props.result[11])} searchWords={[this._termCleanup(this.props.query)]} /></span>;
        }
    }

    _getPrices(prices) {
        if (prices.length > 0) {
            return (
                <div className='results-products-item-pop-link'>
                    Display Quantity Pricing
                    <div className="popover" role="tooltip">
                        <table className='pop-link-table'>
                            <thead><tr><th className="quantity">Quantity</th><th className="price">Price</th></tr></thead>
                            <tbody>
                                {prices.map((price, i) =>
                                    <tr key={i}>
                                        <td className='quantity'>{price.qty}</td>
                                        <td className='price'>{(price.isDiscountPrice ? "$" + price.discountPrice.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') : price.price) +
                                            (price.isDiscountPrice ? (price.discountEachPrice.length === 0 ? '' : ' ' + price.discountEachPrice) :
                                                (price.eachPrice.length === 0 ? '' : ' ' + price.eachPrice))
                                        }</td>
                                    </tr>)
                                }
                            </tbody>
                        </table>
                    </div>
                </div>);
        }
    }

    _qtyCheck() {
        let maxQty = parseInt(this.props.result[12]);
        if (parseInt(this.qtyInput.value) > maxQty) {
            this.setState({ quantityError: true });
        }
        else {
            this.setState({ quantityError: false });
        }
    }

    _qtyInputCheck(event) {
        var charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            event.preventDefault();
            event.stopPropagation();
        }
    }

    _qtyCleanInput(e) {
        e.target.value = e.target.value.replace(/\D/g, '');
    }

    _showAddToCartButton() {
        return (
            <div>
                <a className={`AddToCartDialogLink add-cart visible-lg-inline-block hidden-sm hidden-xs ${this.state.addedToCart ? `hidden` : ``}`} data-idx={this.props.rowNum} data-modal-height='1050' data-modal-width='1000' href='#' onClick={this._addToDialogClick.bind(this, window.bootstrap.addToCartPageDialogUrl, true)}>Add to Cart</a>
                <a className={`AddToCartLink add-cart visible-xs-inline-block hidden-lg hidden-md ${this.state.addedToCart ? `hidden` : ``}`} data-idx={this.props.rowNum} href='#' onClick={this._addToClick.bind(this, window.bootstrap.addToCartPageUrl)}>Add to Cart</a>
                <div className={`item-in-cart ${this.state.addedToCart ? `` : `hidden`}`}>
                    <a href={window.bootstrap.cartPageUrl}><img src="/site/ellsworth/static/img/checkmark.png" alt="In Cart Check" /> <span>Item in Cart</span></a>
                </div >
            </div>
        );
    }

    _showDisabledButton() {
        return (
            <div>
                <button type='button' disabled className='add-cart btn btn-default btn-140 browse disabled-btn'>Add to Cart</button>
            </div>
        );
    }

    _toggleTooltip() {
        let newState = !this.state.tooltipOpen;
        this.setState({ tooltipOpen: newState });
    }

    _addedRemoved(event) {
        var boundAddToCompare = AddToCompareCheckbox.bind(this.compareCheckbox);
        boundAddToCompare();
        var compAddedEvent = '';
        var compRemovedEvent = '';
        if (this.props.path.indexOf('search') > -1) {
            compAddedEvent = 'searchCompareChecked';
            compRemovedEvent = 'searchCompareUnchecked';
        }
        else {
            compAddedEvent = 'navprodCompareChecked';
            compRemovedEvent = 'navprodCompareUnchecked';
        }
        if (this.compareCheckbox.checked) {
            dataLayer.push({ 'event': compAddedEvent });
            this.setState({ "addedToCompare": true });
            this.addRemoveSpan.innerHTML = '<br/>&nbsp;&nbsp;Added to Compare';
            setTimeout(() => {
                this.addRemoveSpan.innerHTML = '';
            }, 4000);
        }
        if (!this.compareCheckbox.checked) {
            this.setState({ "addedToCompare": false });
            dataLayer.push({ 'event': compRemovedEvent });
            this.addRemoveSpan.innerHTML = '<br/>Removed from Compare';
            setTimeout(() => {
                this.addRemoveSpan.innerHTML = '';
            }, 4000);
        }
    }

    _prodAdded() {
        //var prodAddedEvent = '';
        //if (this.props.path.indexOf('search') > -1) {
        //    prodAddedEvent = 'searchAddtoCart';
        //}
        //else {
        //    prodAddedEvent = 'navprodAddtoCart';
        //}
        let prices = this.props.result[7] != '' ? JSON.parse(this.props.result[7]) : [];
        let requestedQty = parseInt(this.qtyInput.value);
        let finalPrice = 0;
        for (let price of prices) {
            let addedPrice = price.price.replace('$', '').replace(',', '');
            if (price.qty.indexOf('-') != -1) {
                let qtyRange = price.qty.split('-');
                if (requestedQty >= qtyRange[0] && requestedQty < qtyRange[1])
                    finalPrice = parseFloat(addedPrice);
            }
            else if (price.qty.indexOf('+') != -1) {
                let qtyPrice = price.qty.replace('+', '');
                if (requestedQty >= qtyPrice)
                    finalPrice = parseFloat(addedPrice);
            }
            else if (parseInt(price.qty) == requestedQty) {
                finalPrice = parseFloat(addedPrice);
            }
        }
        if (finalPrice == 0)
            return;
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
            'event': 'add_to_cart',
            'ecommerce': {
                'currency': this.props.country === 'USA' ? 'USD' : 'CAD',
                'value': finalPrice,
                'items': [{
                    'item_name': this.props.result[0],
                    'item_id': this.props.result[21],
                    'item_number': this.props.result[2],
                    'price': finalPrice,
                    'quantity': parseInt(this.qtyInput.value),
                    'item_brand': this.props.result[20],
                    'item_subbrand': this.props.result[22]
                }]
            }
        });
    }

    _addToDialogClick(url, cart: boolean, e) {
        e.stopPropagation();
        e.preventDefault();
        this._prodAdded();
        url = this._addToUrl(url);
        launchModal(
            url,
            e.target.getAttribute('data-modal-height'),
            e.target.getAttribute('data-modal-width'),
            "false",
            UpdateCartCounts
        );
        if (!this.state.addedToCart && cart) {
            this.setState({ addedToCart: cart });
        }
    }
    _addToClick(url, e) {
        e.stopPropagation();
        e.preventDefault();
        this._prodAdded();
        url = this._addToUrl(url);
        window.location.assign(url);
        return false;
    }

    _selectItem() {
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
            event: 'select_item',
            ecommerce: {
                currency: this.props.country === 'USA' ? 'USD' : 'CAD',
                items: [{
                    item_number: this.props.result[2],
                    item_id: this.props.result[21],
                    item_name: this.props.result[0],
                    index: this.props.rowNum,
                    item_brand: this.props.result[20],
                    price: parseFloat(this.props.result[3].replace(/\$/, '').replace(/,/, '').split(" ")[0].trim()),
                    quantity: parseInt(this.qtyInput.value)
                }]
            }
        });
    }

    _addToUrl(urlBase) {
        var sku = this.props.result[1];
        var qty = this.qtyInput.value;
        if ((!(qty)) || qty.length == 0 || qty == "0" || qty == "")
            qty = "1";
        return urlBase + "?item=" + sku + "&qty=" + qty;
    }

    _getSoldAs() {
        let tooltip = <Tooltip id={'tooltip-' + this.props.rowNum} className="tooltip">{this.props.result[14]}</Tooltip>;
        if (this.props.result[13] === 'true' && this.props.result[10].length > 0) {
            if (this.props.result[14] === null || this.props.result[14].length < 1) {
                return <p className="results-products-item-pack">{this.props.result[10]}</p>;
            }
            else {
                return (
                    <p className="results-products-item-pack">
                        {this.props.result[10]}&nbsp;
                        <span>
                            <OverlayTrigger overlay={tooltip} placement="top">
                                <a className="info-circle"></a>
                            </OverlayTrigger>
                        </span>
                    </p>
                );
            }
        }
        else {
            return '';
        }
    }

    _termCleanup(term: string) {
        if (term == null) {
            return term;
        }
        if (term.match(/\\"/)) {
            term = term.replace(/\\"/g, '"');
        }
        if (term.match(/\\'/)) {
            term = term.replace(/\\'/g, "'");
        }

        return term;
    }
}